"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetService = void 0;
const HttpRequest_1 = require("../HttpRequest");
exports.assetService = {
    getScene(auth, assetId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new HttpRequest_1.HttpRequest().get('/assets/' + assetId + '/scene?assetVersion=' + auth.assetVersionType.toString(), auth.token);
        });
    },
    putScene(auth, assetId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new HttpRequest_1.HttpRequest().put('/assets/' + assetId + '/scene', data, auth.token);
        });
    },
    getImages(auth, assetId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new HttpRequest_1.HttpRequest().get('/assets/' + assetId + '/images', auth.token);
        });
    },
    getImage(auth, assetId, imageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new HttpRequest_1.HttpRequest().getStorage('v1/assets/' + assetId + '/images/' + imageId + '?mode=' + auth.assetVersionType.toString(), auth.token);
        });
    },
    putImage(auth, assetId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const uploadUrl = 'v1/assets/' + assetId + '/images?mode=' + auth.assetVersionType.toString();
            return yield new HttpRequest_1.HttpRequest().postStorage(uploadUrl, data, auth.token);
        });
    },
    uploadThumbnail(auth, assetId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const uploadUrl = 'v1/assets/' + assetId + '/thumbnails?mode=' + auth.assetVersionType.toString();
            return new HttpRequest_1.HttpRequest().postStorage(uploadUrl, data, auth.token);
        });
    },
    downloadThumbnail(auth, assetId) {
        return __awaiter(this, void 0, void 0, function* () {
            const downloadUrl = `v1/assets/${assetId}/thumbnail?mode=${auth.assetVersionType.toString()}`;
            return yield new HttpRequest_1.HttpRequest().getStorage(downloadUrl, auth.token, true);
        });
    }
};
